import request from '@/utils/request'

export const listInventoryManualCodeIntakeRequests = (params) => {
  return request({
    url: '/api/inventory-manual-code-intake-requests',
    method: 'get',
    params
  })
}

export const getInventoryManualCodeIntakeRequest = (id) => {
  return request({
    url: `/api/inventory-manual-code-intake-requests/${id}`,
    method: 'get'
  })
}

export const createInventoryManualCodeIntakeRequest = (data) => {
  return request({
    url: '/api/inventory-manual-code-intake-requests',
    method: 'post',
    data
  })
}

export const cancelInventoryManualCodeIntakeRequest = (id) => {
  return request({
    url: `/api/inventory-manual-code-intake-requests/${id}/cancel`,
    method: 'post'
  })
}

/** 删除已驳回的申请（从清单移除） */
export const deleteInventoryManualCodeIntakeRequest = (id) => {
  return request({
    url: `/api/inventory-manual-code-intake-requests/${id}`,
    method: 'delete'
  })
}

export const rejectInventoryManualCodeIntakeRequest = (id, data) => {
  return request({
    url: `/api/inventory-manual-code-intake-requests/${id}/reject`,
    method: 'post',
    data
  })
}

export const completeInventoryManualCodeIntakeRequest = (id, data) => {
  return request({
    url: `/api/inventory-manual-code-intake-requests/${id}/complete`,
    method: 'post',
    data
  })
}
